import { render, staticRenderFns } from "./ProgrammaExtraInterno.vue?vue&type=template&id=15056d2a&scoped=true&"
import script from "./ProgrammaExtraInterno.vue?vue&type=script&lang=js&"
export * from "./ProgrammaExtraInterno.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammaExtraInterno.vue?vue&type=style&index=0&id=15056d2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15056d2a",
  null
  
)

export default component.exports